// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { databaseCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-database-check': IconDatabaseCheck;
    }
}

/**
 * The icon component for the 'databaseCheck' icon
 */
export class IconDatabaseCheck extends Icon {
    public constructor() {
        super(databaseCheck16X16);
    }
}

registerIcon('icon-database-check', IconDatabaseCheck);
export const iconDatabaseCheckTag = 'nimble-icon-database-check';
